// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/store_shipping/v1/store_shipping.proto (package fingertip.creator.store_shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { CreateShippingRateRequest, CreateShippingRateResponse, DeleteShippingRateRequest, DeleteShippingRateResponse, GetAvailableShippingRatesRequest, GetAvailableShippingRatesResponse, GetPublicShippingRatesRequest, GetPublicShippingRatesResponse, GetShippingConfigRequest, GetShippingConfigResponse, GetShippingRateRequest, GetShippingRateResponse, GetShippingRatesRequest, GetShippingRatesResponse, UpdateShippingRateRequest, UpdateShippingRateResponse, UpsertShippingConfigRequest, UpsertShippingConfigResponse, ValidateShippingRateRequest, ValidateShippingRateResponse } from "./store_shipping_pb.js";

/**
 * Admin/Creator endpoints
 *
 * @generated from rpc fingertip.creator.store_shipping.v1.StoreShippingService.UpsertShippingConfig
 */
export const upsertShippingConfig = {
  localName: "upsertShippingConfig",
  name: "UpsertShippingConfig",
  kind: MethodKind.Unary,
  I: UpsertShippingConfigRequest,
  O: UpsertShippingConfigResponse,
  service: {
    typeName: "fingertip.creator.store_shipping.v1.StoreShippingService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_shipping.v1.StoreShippingService.GetShippingConfig
 */
export const getShippingConfig = {
  localName: "getShippingConfig",
  name: "GetShippingConfig",
  kind: MethodKind.Unary,
  I: GetShippingConfigRequest,
  O: GetShippingConfigResponse,
  service: {
    typeName: "fingertip.creator.store_shipping.v1.StoreShippingService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_shipping.v1.StoreShippingService.CreateShippingRate
 */
export const createShippingRate = {
  localName: "createShippingRate",
  name: "CreateShippingRate",
  kind: MethodKind.Unary,
  I: CreateShippingRateRequest,
  O: CreateShippingRateResponse,
  service: {
    typeName: "fingertip.creator.store_shipping.v1.StoreShippingService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_shipping.v1.StoreShippingService.UpdateShippingRate
 */
export const updateShippingRate = {
  localName: "updateShippingRate",
  name: "UpdateShippingRate",
  kind: MethodKind.Unary,
  I: UpdateShippingRateRequest,
  O: UpdateShippingRateResponse,
  service: {
    typeName: "fingertip.creator.store_shipping.v1.StoreShippingService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_shipping.v1.StoreShippingService.DeleteShippingRate
 */
export const deleteShippingRate = {
  localName: "deleteShippingRate",
  name: "DeleteShippingRate",
  kind: MethodKind.Unary,
  I: DeleteShippingRateRequest,
  O: DeleteShippingRateResponse,
  service: {
    typeName: "fingertip.creator.store_shipping.v1.StoreShippingService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_shipping.v1.StoreShippingService.GetShippingRate
 */
export const getShippingRate = {
  localName: "getShippingRate",
  name: "GetShippingRate",
  kind: MethodKind.Unary,
  I: GetShippingRateRequest,
  O: GetShippingRateResponse,
  service: {
    typeName: "fingertip.creator.store_shipping.v1.StoreShippingService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_shipping.v1.StoreShippingService.GetShippingRates
 */
export const getShippingRates = {
  localName: "getShippingRates",
  name: "GetShippingRates",
  kind: MethodKind.Unary,
  I: GetShippingRatesRequest,
  O: GetShippingRatesResponse,
  service: {
    typeName: "fingertip.creator.store_shipping.v1.StoreShippingService"
  }
};

/**
 * Public endpoints for cart
 *
 * @generated from rpc fingertip.creator.store_shipping.v1.StoreShippingService.GetAvailableShippingRates
 */
export const getAvailableShippingRates = {
  localName: "getAvailableShippingRates",
  name: "GetAvailableShippingRates",
  kind: MethodKind.Unary,
  I: GetAvailableShippingRatesRequest,
  O: GetAvailableShippingRatesResponse,
  service: {
    typeName: "fingertip.creator.store_shipping.v1.StoreShippingService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_shipping.v1.StoreShippingService.GetPublicShippingRates
 */
export const getPublicShippingRates = {
  localName: "getPublicShippingRates",
  name: "GetPublicShippingRates",
  kind: MethodKind.Unary,
  I: GetPublicShippingRatesRequest,
  O: GetPublicShippingRatesResponse,
  service: {
    typeName: "fingertip.creator.store_shipping.v1.StoreShippingService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_shipping.v1.StoreShippingService.ValidateShippingRate
 */
export const validateShippingRate = {
  localName: "validateShippingRate",
  name: "ValidateShippingRate",
  kind: MethodKind.Unary,
  I: ValidateShippingRateRequest,
  O: ValidateShippingRateResponse,
  service: {
    typeName: "fingertip.creator.store_shipping.v1.StoreShippingService"
  }
};
